import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  Button,
} from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

const LowBalanceModal = ({ open, onClose }) => {
  const handleClose = () => {
   // console.log("close---------->");
    onClose(); // Modal ko close karega
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "20px",
          padding: "15px 10px",
          width: "330px",
          position: "relative",
          overflow: "visible",
        },
      }}
    >
      {/* Floating Icon */}
      <Box
        sx={{
          width: 60,
          height: 60,
          borderRadius: "50%",
          backgroundColor: "#E7F2FF",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
          top: -30,
          left: "50%",
          transform: "translateX(-50%)",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        }}
      >
        <WarningAmberRoundedIcon sx={{ fontSize: 35, color: "#FFB300" }} />
      </Box>

      <DialogContent sx={{ mt: 3 }}>
        <Typography
          variant="h6"
          align="center"
          sx={{ fontWeight: 700, mb: 1 }}
        >
          Low Balance
        </Typography>

        <Typography
          align="center"
          sx={{ fontSize: "14px", color: "#6B6B6B", mb: 2 }}
        >
          Can't place order due to low balance
        </Typography>

        <Button
          fullWidth
          sx={{
            backgroundColor: "#00C26D",
            color: "#fff",
            fontWeight: 600,
            fontSize: "16px",
            textTransform: "none",
            borderRadius: "15px",
            padding: "10px",
            "&:hover": {
              backgroundColor: "#00a85d",
            },
          }}
          onClick={handleClose}  // <-- FIXED
        >
          OK
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default LowBalanceModal;
